"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentName = void 0;
const utils_1 = require("@hc-frontend/utils");
const environment_names_1 = require("../../enums/environment-names");
/**
 * Get the name of the environment.
 *
 * @public
 *
 * @param {string} href A valid URL
 *
 * @returns {string} The name of the environment
 */
function getEnvironmentName(href = window.location.hostname) {
    const envs = {
        'qa.': environment_names_1.EnvironmentName.QA,
        'stg.': environment_names_1.EnvironmentName.STG,
    };
    return envs[(0, utils_1.prefixEnvironment)(href)] || environment_names_1.EnvironmentName.PROD;
}
exports.getEnvironmentName = getEnvironmentName;
//# sourceMappingURL=get-environment-name.js.map